export const NEW_MESSAGE_DIALOG = 'app/Messages/NEW_MESSAGE_DIALOG';
export const OPEN_NEW_MESSAGE_DIALOG = 'app/Messages/OPEN_NEW_MESSAGE_DIALOG';
export const CANCEL_NEW_MESSAGE_DIALOG = 'app/Messages/CANCEL_NEW_MESSAGE_DIALOG';
export const SUBMIT_NEW_MESSAGE_FORM = 'app/Messages/SUBMIT_NEW_MESSAGE_FORM';
